<header id="header">
  <!-- <div class="topbar"> -->
    <div class="overlay"></div>
    <div class="container-fluid">
      <div class="container px-0">
        <nav
          class="navbar navbar-expand-xl"
          style="border-bottom: 2px solid white"
        >
          <a [routerLink]="['']" class="navbar-brand">
            <!-- <h1 class="text-white display-6">LT Academy HUB</h1> -->
            <img
              src="assets/lta/logo.png"
              class="img-fluid rounded"
              style="width: auto; height: 120px"
            />
          </a>
          <button
            class="navbar-toggler py-2 px-3"
            type="button"
            (click)="toggleNavbar()"
          >
            <span class="fa fa-bars text-primary"></span>
          </button>
          <div class="collapse navbar-collapse" [class.show]="isNavbarOpen">
            <div class="navbar-nav d-lg-none">
              <a [routerLink]="['']" class="nav-item nav-link">Home</a>
              <a href="http://ltatalks.site/" class="nav-item nav-link"
                >LTA Talks</a
              >

              <a href="http://ltatweets.site/" class="nav-item nav-link"
                >LTA Tweets</a
              >
              <a href="https://umyoappt.site/" class="nav-item nav-link"
                >Booking</a
              >
              <a href="https://umyoevents.site/" class="nav-item nav-link"
                >Events</a
              >
              <a href="https://live.umyoconvo.site/" class="nav-item nav-link"
                >Podcast</a
              >
              <a href="https://Umyoeducator.com" class="nav-item nav-link"> Educator</a>
              <a href="https://UPMRadio.site/" class="nav-link nav-item"
                    >Radio</a
                  >
              <a [routerLink]="['/cf']" class="nav-item nav-link"
                >Card Features</a
              >
            
            </div>
            <div class="d-md-flex m-3 ms-auto align-items-center d-none">
              <p class="text-white" style="margin: 2px 25px; font-size: 25px">
                UMYO
              </p>
              <button
                class="btn-search btn border border-white btn-md-square rounded-circle me-4"
                data-bs-toggle="modal"
                data-bs-target="#searchModal"
              >
                <i class="fas fa-search text-white"></i>
              </button>
              <a href="#" class="position-relative me-4 my-auto">
                <i class="fa fa-shopping-cart text-white fa-2x"></i>
              </a>
              <a href="#register" class="my-auto">
                <button class="btn btn-primary ">
                  Get Started
                </button>
              </a>
            </div>

            <!-- Mobile icons -->
            <div class="d-flex m-3 ms-auto d-md-none align-items-center">
              <p class="text-white pb-0" style=" font-size: 22px">
                UMYO
              </p>
              <button
                class="btn-search btn border border-white btn-md-square rounded-circle mx-3 px-2"
                data-bs-toggle="modal"
                data-bs-target="#searchModal"
              >
                <i class="fas fa-search text-white"></i>
              </button>
              <a href="#" class="position-relative me-3 my-auto">
                <i class="fa fa-shopping-cart text-white "></i>
              </a>
              <a href="#register" class="btn btn-primary p-3">
                  Get Started
              </a>
            </div>
          </div>
        </nav>
        <nav class="navbar navbar-expand-lg d-lg-block d-none menu-nav2">
          <div class="container-fluid p-0">
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav mb-2 mb-lg-0">
                <li class="nav-item">
                  <a [routerLink]="['']" class="nav-link">Home</a>
                </li>
                <li class="nav-item">
                  <a href="http://ltatalks.site/" class="nav-link">LTA Talks</a>
                </li>
                <li class="nav-item">
                  <a href="http://ltatweets.site/" class="nav-link">LTA Tweets</a>
                </li>
                <li class="nav-item">
                  <a href="https://umyoappt.site/" class="nav-link">Booking</a>
                </li>
                <li class="nav-item">
                  <a href="https://umyoevents.site/" class="nav-link">Events</a>
                </li>
                <li class="nav-item">
                  <a href="https://live.umyoconvo.site/" class="nav-link"
                    >Podcast</a
                  >
                </li>
                
                <li class="nav-item">
                  <a href="https://Umyoeducator.com" class=" nav-link"> Educator</a>
                </li>
                <li class="nav-item">
                  <a href="https://UPMRadio.site/" class="nav-link"
                    >Radio</a
                  >
                </li>
                <li class="nav-item">
                  <a class="nav-link" [routerLink]="['/cf']">Card Features</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>

    <!-- Navbar End -->

    <!-- Modal Search Start -->
    <div
      class="modal fade"
      id="searchModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-fullscreen">
        <div class="modal-content rounded-0">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Search by keyword</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body d-flex align-items-center">
            <div class="input-group w-75 mx-auto d-flex">
              <input
                type="search"
                class="form-control p-3"
                placeholder="keywords"
                aria-describedby="search-icon-1"
              />
              <span id="search-icon-1" class="input-group-text p-3"
                ><i class="fa fa-search"></i
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Search End -->

    <!-- Hero Start -->
  <!-- </div> -->
</header>
  <!-- HERO -->
  <section class="tc-hero">
    <div class="tc-hero-inner">
      <div class="tc-badge">📋 Legal Document</div>
      <h1>Terms &amp; <span>Conditions</span></h1>
      <p>Please read these terms carefully before participating in the LT Academy Connect platform and its associated ecosystems.</p>
      <div class="tc-meta">
        <div class="tc-meta-item"><span>📅</span> Effective: June 1, 2026</div>
        <div class="tc-meta-item"><span>🔄</span> Last Updated: June 2026</div>
        <div class="tc-meta-item"><span>🏢</span> UMYO Platform</div>
      </div>
    </div>
  </section>

  <!-- BODY -->
  <div class="tc-body">

    <!-- TABLE OF CONTENTS -->
    <aside class="toc">
      <h3>Contents</h3>
      <ol>
        <li><a href="/terms#section-1">Expression &amp; Ecosystem Scope</a></li>
        <li><a href="/terms#section-2">Non-Discrimination &amp; Mission Alignment</a></li>
        <li><a href="/terms#section-3">Member Appeals &amp; Review Process</a></li>
      </ol>
      <div class="toc-footer">
        Questions? <a href="/#register-form" style="color:var(--royal);">Contact Us</a>
      </div>
    </aside>

    <!-- SECTIONS -->
    <main class="tc-content">

      <!-- SECTION 1 -->
      <div class="tc-section" id="section-1">
        <div class="section-header">
          <div class="section-icon">🌐</div>
          <div class="section-title-wrap">
            <div class="section-num">Section 01</div>
            <h2>Expression and Ecosystem Scope</h2>
          </div>
        </div>

        <p>The Platform operates as a collection of mission-specific digital ecosystems. Each ecosystem functions as a purpose-driven private online association with a defined scope of discussion.</p>

        <p>Members are encouraged to engage in open expression within the stated mission and intended purpose of the ecosystem they have joined. Expression is permitted to the extent it aligns with the ecosystem's defined focus and participation standards.</p>

        <p>Content, discussions, or activities that fall outside the stated mission or scope of a particular ecosystem may be moderated, restricted, redirected, or removed at the Company's discretion.</p>

        <p>The Company does not regulate expression based on viewpoint alone. Moderation decisions are based on alignment with ecosystem purpose, adherence to participation standards, and compliance with Platform-wide policies.</p>

        <p>Participation in any ecosystem is conditional and subject to continued compliance with applicable guidelines. Access to an ecosystem is a revocable license and may be suspended or terminated for violations of its stated mission, conduct standards, or Platform policies.</p>

        <div class="highlight-box">
          <span class="hi-icon">🔒</span>
          <p>Membership in one ecosystem does not grant rights, privileges, or expression authority within any other ecosystem.</p>
        </div>

        <p>UMYO operates multiple mission-specific private digital ecosystems. Participation is voluntary and conditioned upon agreement to the mission and standards of each ecosystem.</p>

        <p>The platform does not guarantee unrestricted expression. Content may be moderated or removed if deemed outside the mission scope of the selected ecosystem, regardless of viewpoint.</p>

        <div class="highlight-box gold-highlight">
          <span class="hi-icon">💬</span>
          <p>Mission-aligned expression: Speech is free within the mission of the ecosystem — not free across all topics everywhere.</p>
        </div>
      </div>

      <!-- SECTION 2 -->
      <div class="tc-section" id="section-2">
        <div class="section-header">
          <div class="section-icon">⚖️</div>
          <div class="section-title-wrap">
            <div class="section-num">Section 02</div>
            <h2>Non-Discrimination and Mission Alignment</h2>
          </div>
        </div>

        <p>The Company provides access to the Platform without discrimination based on race, color, religion, sex, gender identity, sexual orientation, national origin, disability, political affiliation, or other legally protected characteristics.</p>

        <ul class="tc-list">
          <li>Access to individual ecosystems is conditioned upon agreement to and compliance with that ecosystem's stated mission, scope, and participation standards.</li>
          <li>Moderation decisions are based on conduct, mission alignment, and adherence to Platform policies — not on a member's personal identity or protected characteristics.</li>
        </ul>

        <div class="highlight-box">
          <span class="hi-icon">📌</span>
          <p>The Company reserves the right to suspend or terminate participation in any ecosystem where a member's conduct is inconsistent with its stated purpose or applicable guidelines.</p>
        </div>
      </div>

      <!-- SECTION 3 -->
      <div class="tc-section" id="section-3">
        <div class="section-header">
          <div class="section-icon">📝</div>
          <div class="section-title-wrap">
            <div class="section-num">Section 03</div>
            <h2>Member Appeals and Review Process</h2>
          </div>
        </div>

        <p>Members who believe a moderation action was taken in error may submit a written appeal within <strong>fourteen (14) days</strong> of the action.</p>

        <ul class="tc-list">
          <li>Appeals must include sufficient detail to allow review of the decision, including the relevant ecosystem, date of action, and a description of the basis for the appeal.</li>
          <li>Upon receipt of a valid appeal request, the Company will conduct an internal review of the moderation decision. Review may include evaluation of the original content, applicable ecosystem guidelines, and compliance with Platform policies.</li>
          <li>The Company may uphold, modify, or reverse the original decision at its discretion. Decisions issued upon appeal are final.</li>
          <li>Submission of an appeal does not guarantee reinstatement, refund, or restoration of access. During the review period, access may remain suspended.</li>
        </ul>

        <div class="highlight-box gold-highlight">
          <span class="hi-icon">⚠️</span>
          <p>The Company reserves the right to decline repetitive, abusive, or bad-faith appeals.</p>
        </div>
      </div>

    </main>
  </div>

  <!-- FOOTER -->
  <footer class="tc-footer">
    <strong>LT Academy Connect &copy; 2026</strong>
    Youth. Community. Business. One Movement. &nbsp;|&nbsp;
    <a routerLink="">Return to Home</a>
  </footer>